import { GridColDef, GridInitialState } from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import useApi from "../../../hooks/useGaneshApi";
import { getDateValue, renderDateCell, renderNumberCell } from "utils/dataGrid";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";
import { TasksStats_T } from "../../../types/Brand";
import { useError } from "../../../contexts/ErrorContext";
import { GridRenderCellParams } from "@mui/x-data-grid-premium";
import { Link } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "brand_id", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 50, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const columns_def: GridColDef[] = [
  {
    field: "country_code",
    headerName: "Country Code",
    width: 150,
  },
  {
    field: "name",
    headerName: "Country Name",
    width: 250,
  },
  {
    field: "percent_omni_coverage",
    headerName: "Percent Omni Coverage",
    width: 200,
    renderCell: renderNumberCell,
    renderHeader: (params) => (
      <Tooltip title="Calculated as (Brands with Omni POI coverage / Total top 1000 brands per country) * 100.">
        <span className="MuiDataGrid-columnHeaderTitle">
          {params.colDef.headerName}
        </span>
      </Tooltip>
    ),
  },
  {
    field: "percent_omnis_reviewed",
    headerName: "Percent Omnis Reviewed",
    width: 200,
    renderCell: renderNumberCell,
    renderHeader: (params) => (
      <Tooltip title="Calculated as (Number of Omni brands with reviews in the last 90 days / Total Omni brands with POI) * 100.">
        <span className="MuiDataGrid-columnHeaderTitle">
          {params.colDef.headerName}
        </span>
      </Tooltip>
    ),
  },
  {
    field: "percent_places_reviewed",
    headerName: "Percent Places Reviewed",
    width: 200,
    renderCell: renderNumberCell,
    renderHeader: (params) => (
      <Tooltip title="Calculated as (Number of Non-Omni brands with reviews in the last 90 days / Total Non-Omni brands with POI) * 100.">
        <span className="MuiDataGrid-columnHeaderTitle">
          {params.colDef.headerName}
        </span>
      </Tooltip>
    ),
  },
];

const TasksStatsTable: React.FC<any> = () => {
  const [tasksStatsData, setTasksStatsData] = useState<TasksStats_T[]>([]);
  const [loading, setLoading] = useState(true);

  const { showError } = useError();
  const { apiRequest } = useApi();

  useEffect(() => {
    const fetchTasksStats = async () => {
      try {
        const response = await apiRequest<TasksStats_T[]>(
          `/tasks_reports/tasks_stats`,
          { method: "GET" }
        );
        if (response.data) {
          const formattedData = response.data.map((item) => ({
            ...item,
            percent_omni_coverage: Number(item.percent_omni_coverage),
            percent_omnis_reviewed: Number(item.percent_omnis_reviewed),
            percent_places_reviewed: Number(item.percent_places_reviewed),
          }));
          setTasksStatsData(formattedData);
        }
      } catch (error) {
        console.error(error);
        showError(`Failed to fetch brand places tasks.`);
      } finally {
        setLoading(false);
      }
    };

    fetchTasksStats();
  }, []);

  return (
    <GaneshDataGrid
      loading={loading}
      data={tasksStatsData}
      columns={columns_def}
      gridId="tasks-stats-table"
      defaultGridState={defaultGridState}
      getRowHeight={() => "auto"}
    />
  );
};

export default TasksStatsTable;
